<template>
    <div class="menu-user-container position-relative">
        <!-- BOTÓN DESKTOP (≥1200px) -->
        <!--<a class="btn btn-vehiculo d-none d-xxxl-inline dropdown-toggle" href="#" role="button"
            @click.prevent="toggleDropdown">
            {{ cliente }}
        </a>-->

        <!-- BOTÓN MÓVIL / TABLET (<1200px) -->
        <button class="btn btn-vehiculo-mobile" @click="toggleDropdown" aria-label="Menú Usuario" style="color: white!important;">
            <i :class="['bx', 'bx-cog', { rotate: abierto }]"></i>
        </button>

        <!-- MENÚ MEGA -->
        <div class="mega-user-menu p-3" :class="{ show: abierto }" ref="menuDropdown">

            <div class="d-block mb-3 border-bottom pb-2 text-white fw-bold">
                <div class="text-truncate" title="{{ cliente }}">
                    {{ cliente }}
                </div>

                <div class="small text-white-50 text-truncate">
                    {{ name }}
                </div>
            </div>

            <!-- HEADER MI CUENTA -->
            <div class="mb-3 border-bottom pb-2">
                <h6 class="menu-section-title">Mi Cuenta</h6>
                <ul class="menu-list list-unstyled">
                    <li>
                        <router-link :to="linkMiCuenta" class="menu-link" @click.native="cerrarDropdown">
                            <i class="bx bx-desktop me-2"></i> Mi Cuenta
                        </router-link>
                    </li>
                </ul>
            </div>

            <!-- SECCIONES -->
            <div class="row gx-2">

                <!-- CUENTA -->
                <div class="col-12 col-lg-6 mb-3"
                    v-if="rol_auth.includes('admin') || (rol_auth.includes('cliente') && itemsCuenta.length > 0)">
                    <h6 class="menu-section-title">Pedidos</h6>
                    <ul class="menu-list list-unstyled section-scroll">
                        <li v-for="item in itemsCuenta" :key="item.nombre">
                            <router-link :to="item.to" class="menu-link" @click.native="cerrarDropdown">
                                <i :class="item.icono + ' me-2'"></i>
                                {{ item.nombre }}
                            </router-link>
                        </li>
                    </ul>
                </div>

                <!-- HERRAMIENTAS -->
                <div class="col-12 col-lg-6 mb-3" v-if="rol_auth.includes('admin') || itemsHerramientas.length > 0">
                    <h6 class="menu-section-title">Herramientas</h6>
                    <ul class="menu-list list-unstyled section-scroll">
                        <li v-for="item in itemsHerramientas" :key="item.nombre">
                            <router-link :to="item.to" class="menu-link" @click.native="cerrarDropdown">
                                <i :class="item.icono + ' me-2'"></i>
                                {{ item.nombre }}
                            </router-link>
                        </li>
                    </ul>
                </div>

                <!-- ADMINISTRACIÓN -->
                <div class="col-12 col-lg-6 mb-3" v-if="rol_auth.includes('admin') || itemsAdmin.length > 0">
                    <h6 class="menu-section-title">Administración</h6>
                    <ul class="menu-list list-unstyled section-scroll">
                        <li v-for="item in itemsAdmin" :key="item.nombre">
                            <router-link :to="item.to" class="menu-link" @click.native="cerrarDropdown">
                                <i :class="item.icono + ' me-2'"></i>
                                {{ item.nombre }}
                            </router-link>
                        </li>
                    </ul>
                </div>

                <!-- INDICADORES -->
                <div class="col-12 col-lg-6 mb-3" v-if="rol_auth.includes('admin') || itemsIndicadores.length > 0">
                    <h6 class="menu-section-title">Indicadores</h6>
                    <ul class="menu-list list-unstyled section-scroll">
                        <li v-for="item in itemsIndicadores" :key="item.nombre">
                            <router-link :to="item.to" class="menu-link" @click.native="cerrarDropdown">
                                <i :class="item.icono + ' me-2'"></i>
                                {{ item.nombre }}
                            </router-link>
                        </li>
                    </ul>
                </div>

            </div>

            <hr>

            <!-- LOGOUT -->
            <div class="d-flex align-items-center logout mt-2" @click="$emit('logout')">
                <i class="bx bx-log-out me-2"></i>
                Salir
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MenuUsuario",
    props: {
        cliente: String,
        name: String,
        rol_auth: Array,
        permissions_auth: Array,
        isLoggedin: Boolean,
    },
    data() {
        return {
            abierto: false,
        };
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        toggleDropdown() {
            this.abierto = !this.abierto;
        },
        cerrarDropdown() {
            this.abierto = false;
        },
        handleClickOutside(event) {
            if (
                this.abierto &&
                !this.$refs.menuDropdown.contains(event.target) &&
                !event.target.closest('.btn-vehiculo, .btn-vehiculo-mobile')
            ) {
                this.cerrarDropdown();
            }
        },
        puedeVer(item) {
            // 1. Si es admin, ve todo
            if (this.rol_auth.includes("admin")) return true;

            // 2. Verificar si tiene alguno de los ROLES requeridos
            const tieneRol = item.roles ? item.roles.some(r => this.rol_auth.includes(r)) : false;

            // 3. Verificar si tiene alguno de los PERMISOS requeridos
            const tienePermiso = item.permisos ? item.permisos.some(p => this.permissions_auth.includes(p)) : false;

            // Retorna true si cumple cualquiera de las dos
            return tieneRol || tienePermiso;
        }
    },
    computed: {
        linkMiCuenta() {
            if (this.rol_auth.includes("admin") || this.rol_auth.includes("CustomerService")) return "/AdminDashboard";
            if (this.rol_auth.includes("asesor")) return "/AsesorDashboard";
            if (this.rol_auth.includes("vendedor")) return "/TmkDashboard";
            if (this.rol_auth.includes("cliente")) return "/dashboard";
            return "/";
        },
        itemsCuenta() {
            const items = [
                { nombre: "No Autorizados", to: { name: 'listadocotizaciones', query: { cliente: this.cliente } }, icono: "fa fa-exclamation-triangle", roles: ["cliente"] },
                { nombre: "Autorizados", to: { name: 'listadocotizacionesaut', query: { cliente: this.cliente } }, icono: "fa fa-check-circle", roles: ["cliente"] }
            ];
            return items.filter(i => this.puedeVer(i));
        },

        itemsHerramientas() {
            const items = [
                { nombre: "Cotizador", to: "/HelpCotizador", icono: "fa fa-calculator", roles: ["cliente", "Cotizador-Mostrador"] },
                { nombre: "Doctos Electrónicos", to: "/consultdocumentosSat", icono: "bx bx-file-find", roles: ["cliente"] }
            ];
            return items.filter(i => this.puedeVer(i));
        },

        itemsIndicadores() {
            const items = [
                { nombre: "Ventas Generales", to: { name: 'indicadores' }, icono: "bx bx-line-chart", roles: ["admin", "supervisor", "manager"] },
                { nombre: "Ventas Producto", to: { name: 'productosdetailsbuy' }, icono: "bx bx-line-chart", roles: ["admin", "supervisor", "manager"] },
                { nombre: "Comportamiento Clientes", to: { name: 'DetalleClientes' }, icono: "bx bx-group", roles: ["admin", "supervisor", "manager"] }
            ];
            return items.filter(i => this.puedeVer(i));
        },

        itemsAdmin() {
            const items = [
                { nombre: "Productos", to: "/Productos", icono: "fa fa-box", roles: ["admin"] },
                { nombre: "Carga de productos", to: "/actualizarprods", icono: "fa fa-upload", roles: ["admin"] },
                { nombre: "Usuarios", to: "/users", icono: "fa fa-users", roles: ["admin"], permisos: ["users-read"] },
                { nombre: "Banner's", to: "/posts", icono: "fa fa-image", roles: ["admin", "MKTG"], permisos: ["publicaciones-read"] },
                { nombre: "Documentos PDFS", to: "/documentoindexview", icono: "fa fa-file-pdf", roles: ["admin", "MKTG"], permisos: ["pdfcatalogo-create"] },
                { nombre: "Fichas", to: { name: 'AdminFichas' }, icono: "fa fa-file", roles: ["admin", "MKTG"] },
                { nombre: "Admin. Pagos", to: { name: 'PagosAdmin' }, icono: "fa fa-upload", roles: ["admin", "PaymentAdmin", "asesor", "vendedor"] },
                { nombre: "Config. Correos", to: { name: 'Correos' }, icono: "fa fa-upload", roles: ["admin"] },
                { nombre: "Detalles Carrito", to: { name: 'DetailsErrosCarts' }, icono: "bx bx-cart-alt", roles: ["admin"] },
                {
                    nombre: "Detalles Producto",
                    to: "/DetailsErrosProds",
                    icono: "bx bx-package text-danger",
                    roles: ["admin"],
                },
                {
                    nombre: "Sync Prods",
                    to: "/Sync",
                    icono: "bx bx-sync",
                    roles: ["admin"],
                },
                {
                    nombre: "Admin Anuncios",
                    to: { name: 'anunciosadmin' },
                    icono: "bx bxs-megaphone",
                    roles: ["admin"],
                },
            ];
            return items.filter(i => this.puedeVer(i));
        }
    }
};
</script>

<style scoped>
.menu-user-container {
    position: relative;
}

/* Botón móvil */
.btn-vehiculo-mobile {
    background: none;
    border: none;
    padding: 6px 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-vehiculo-mobile i {
    font-size: 1.4rem;
    transition: transform 0.3s ease;
}

.btn-vehiculo-mobile i.rotate {
    transform: rotate(90deg);
}

/* Mega menú */
.mega-user-menu {
    position: absolute;
    right: 0;
    top: 100%;
    min-width: 350px;
    background: rgba(6, 40, 60, 0.95);
    backdrop-filter: blur(6px);
    border-radius: 8px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
    display: none;
    z-index: 2000;
}

.mega-user-menu.show {
    display: block;
    animation: megaSlide 0.25s ease-out;
}

@keyframes megaSlide {
    from {
        transform: translateY(10px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.menu-section-title {
    color: #fff;
    font-weight: 700;
    font-size: 0.95rem;
    text-transform: uppercase;
}

.menu-link {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
    font-size: 0.92rem;
    display: block;
    padding: 4px 0;
    transition: 0.2s;
}

.menu-link:hover {
    color: #1CA3DF;
    transform: translateX(4px);
}

.logout {
    cursor: pointer;
    color: #fff;
    font-weight: 600;
}

.logout:hover {
    color: #1CA3DF;
}

/* Scroll */
.section-scroll {
    max-height: 180px;
    overflow-y: auto;
}
</style>